import React, { useState } from 'react';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Autoplay } from 'swiper';
import { MktTestimonial } from './Testimonial';
import { MktBgColorsTypes, MktTestimonialView } from './types';
import 'swiper/css';
import { Media } from '../../utils/breakpoints-helper';
import './index.css';

export interface MktTestimonialsSliderProps {
  testimonials: MktTestimonialView[];
  autoplaySpeedTransition?: number;
  bgColor?: MktBgColorsTypes;
}

export const MktTestimonialsSlider: React.FC<MktTestimonialsSliderProps> = ({
  testimonials,
  autoplaySpeedTransition = 5000,
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const handleChange = (activeIndex: number) => {
    setActiveIndex(activeIndex);
  };
  const isDesktop = Media().xl();

  const SwiperButtonNext = () => {
    const swiper = useSwiper();
    const isFinished = testimonials.length === swiper.activeIndex + 1;
    return (
      <button
        type="button"
        className="whl-border-white whl-text-white"
        onClick={() => (isFinished ? swiper.slideTo(0) : swiper.slideNext(500))}
      >
        <i className="whl-icon wh-icon-arrow-line-right whl-flex whl-h-[58.88px] whl-w-[59.32px] whl-items-center whl-justify-center whl-rounded-full whl-border whl-text-xl whl-text-white xl:whl-h-[76.43px] xl:whl-w-[76.43px] xl:whl-text-4xl" />
      </button>
    );
  };

  const SwiperButtonPrev = () => {
    const swiper = useSwiper();
    const isStarted = swiper.activeIndex === 0;
    return (
      <button
        type="button"
        className=" whl-border-white whl-text-white"
        onClick={() =>
          isStarted
            ? swiper.slideTo(testimonials.length)
            : swiper.slidePrev(500)
        }
      >
        <i className="whl-icon wh-icon-arrow-line-left whl-flex whl-h-[58.88px] whl-w-[59.32px] whl-items-center whl-justify-center whl-rounded-full whl-border whl-text-xl xl:whl-h-[76.43px] xl:whl-w-[76.43px] xl:whl-text-4xl " />
      </button>
    );
  };

  const getActiveTestimonial = (
    isDesktop: boolean,
    index: number,
    activeIndex: number,
  ): boolean => {
    if (!isDesktop) {
      return true;
    } else {
      return index === activeIndex;
    }
  };

  return (
    <section className="testimonials whl-h-screen">
      <Swiper
        slidesPerView={isDesktop ? 3 : 1}
        centeredSlides
        spaceBetween={60}
        onActiveIndexChange={i => handleChange(i.activeIndex)}
        autoplay={{
          delay: autoplaySpeedTransition,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className="whl-mx-auto whl-flex whl-w-screen whl-flex-col"
      >
        {testimonials.map((testimonial, index) => {
          return (
            <SwiperSlide key={testimonial.name}>
              <MktTestimonial
                testimonial={testimonial}
                isActive={getActiveTestimonial(isDesktop, index, activeIndex)}
              />
            </SwiperSlide>
          );
        })}
        <div className=" whl-flex whl-items-center whl-justify-center whl-gap-x-[16px] whl-pt-[51.3px] xl:whl-pt-[10px]">
          <SwiperButtonPrev />
          <div className="whl-flex whl-items-center whl-justify-center whl-gap-2 xl:whl-w-[228.57px] xl:whl-gap-4">
            <span className=" whl-flex whl-justify-center whl-text-[20px] whl-font-light whl-text-[#FFFFFF] ">
              0{activeIndex + 1}
            </span>
            <span className=" whl-flex whl-justify-center whl-text-[20px] whl-font-light whl-text-[#FFFFFF]">
              -
            </span>
            <span className=" whl-flex whl-justify-center whl-text-[20px] whl-font-light whl-text-[#FFFFFF]">
              0{testimonials.length}
            </span>
          </div>
          <SwiperButtonNext />
        </div>
      </Swiper>
    </section>
  );
};
